import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private httpClient: HttpClient) {}

  public get(query: string): Observable<any> {
    return this.httpClient.get('https://nominatim.openstreetmap.org/search', {
      params: {
        q: query,
        format: 'json',
      },
    });
  }

  public getZipcode(lat: number, lon: number): Observable<any> {
    return this.httpClient.get('https://nominatim.openstreetmap.org/reverse', {
      params: {
        format: 'jsonv2',
        lat,
        lon,
        addressdetails: 1,
      },
    });
  }
  public getCoordsFromZipcode(zipcode: string, countryCode: string = 'us'): Observable<any> {
    return this.httpClient.get('https://nominatim.openstreetmap.org/search', {
      params: {
        postalcode: zipcode,
        country: countryCode,
        format: 'json',
        bounded: '1',
      },
    });
  }
}
